import { AxiosError } from "axios";
import { useQuery } from "@tanstack/react-query";
import { DefaultFilter } from "../../../@types/filter";
import { Totem } from "../../../@types/totem";
import { Paginated } from "../../../@types/paginated";
import { apisiseci } from "../../api";
import { useDefaultSearchParams } from "../../../hooks/useSearchParams";
import { useCurrentOrgao } from "../../../hooks/useCurrentOrgao";

type Props = DefaultFilter & {
    orgao?: string;
    orgao_id?: string;
    status?: string;
    data_edicao?: string;
    data_atualizacao?: string;
};

export function useTotemList(params?: Props) {
    const token = localStorage.getItem("gov_access_token_sso");
    const currentOrgaoId = useCurrentOrgao();
    const defaultParams = useDefaultSearchParams();
    params = { ...defaultParams, ...params };

    // Adicionar filtro de órgão se disponível
    if (currentOrgaoId && !params.orgao) {
        params = { ...params, orgao_id: currentOrgaoId.toString() };
    }

    return useQuery<Paginated<Totem>, AxiosError<{ detail: string }>>({
        enabled: !!token,
        queryKey: ['totem', 'list', params, currentOrgaoId],
        queryFn: async () => {
            const response = await apisiseci.get<Paginated<Totem>>(
                "/cms/totens/",
                { headers: { Authorization: `Bearer ${token}` }, params }
            );
            return response.data;
        },
    });
}
